(function () {
	const OFFSET = 200; // Need this for LD Scroll
	const isRTL = getComputedStyle(document.body).direction === "rtl";

  const initScrollProducts = () => {
    const sections = document.querySelectorAll(".section-scroll-products");

    sections.forEach((section) => {
      if (section.classList.contains("scroll_initialized")) return;
      section.classList.add("scroll_initialized");

      const parent = section.querySelector(".scroll-products__container");
      const child = section.querySelector(".scroll-products");
      const innerDiv = child?.querySelector(".scroll-products__products");
      const productCard = section.querySelector(".scroll-products__item");
      const wrapper = section.querySelector(".scroll-products__wrapper");

      if (!parent || !child || !innerDiv) return;

      const productsCount = +child.dataset.productsCount;
      const isSingleProduct = productsCount === 1;

      const childBefore = window.getComputedStyle(child, "::before");
      const slideHeight = parseFloat(childBefore.height) || 0;

      const updateMinHeight = () => {
        if (!productCard) return;

        wrapper.style.maxHeight = `${productCard.offsetHeight}px`;

        let productCardHeight = productCard.offsetHeight + 96 + OFFSET;
        if (productCardHeight < slideHeight) {
          productCardHeight = slideHeight;
        }

        if (parseInt(child.style.minHeight, 10) !== productCardHeight) {
          child.style.minHeight = `${productCardHeight}px`;
        }
      };

      updateMinHeight();

      let ticking = false;

      const handleScroll = () => {
        const parentRect = parent.getBoundingClientRect();
        const childRect = child.getBoundingClientRect();

        const scrollY = window.pageYOffset;

        const startScroll = parentRect.top + scrollY - OFFSET;
        const endScroll = parentRect.bottom + scrollY - childRect.height;

        const isSmallScreen = window.innerWidth < 990;
        const isMediumScreen = window.innerWidth < 1360;

        const scrolled = Math.min(
          Math.max((scrollY - startScroll) / (endScroll - startScroll), 0),
          1
        );

        let translateY = -115 + 110 * scrolled;
        let translateX = -50;

        if (productsCount === 4 && !isSmallScreen) {
          translateY = -50;
          translateX = !isMediumScreen
            ? 70 - 70 * scrolled
            : 76 - 76 * scrolled;
        } else if (productsCount !== 4 && !isSmallScreen && !isSingleProduct) {
          translateY = -50;
          translateX = !isMediumScreen
            ? 60 - 60 * scrolled
            : 67 - 67 * scrolled;
        } else if (!isSmallScreen && isSingleProduct) {
          translateX = 0;
          translateY = -50 * scrolled;
        }

        innerDiv.style.transform = `translate3d(${
          (isRTL && !isSmallScreen) ? -translateX : translateX
        }%, ${translateY}%, 0)`;
      };

      const onScroll = () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            handleScroll();
            ticking = false;
          });
          ticking = true;
        }
      };

      const handleResize = () => {
        updateMinHeight();
        handleScroll();
      };

      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", handleResize);

      handleScroll();
    });
  };

  initScrollProducts();

  document.addEventListener("shopify:section:load", initScrollProducts);
})();
